import { useState } from 'react';
import { I18n } from 'i18n';
import { useSelector, useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { Table as TableUI } from 'antd';
import { PageContent, Drawer } from 'components';
import { getCurrentMe } from 'apollo/account';
import { NotificationEdit } from '../components/notification-edit';

const { Column } = TableUI;

export function ListNotifications() {
  const dispatch = useDispatch();
  const customerFromRedux = useSelector(({ customers }) => customers?.data);
  const [visible, setVisible] = useState(false);
  const [isEditForm, setIsEditForm] = useState(false);
  const [selectedChannel, setSelectedChannel] = useState(null);

  const dataChannels = customerFromRedux?._id
    ? [
        {
          key: 'whatsapp',
          channel: 'WhatsApp',
          groupId: customerFromRedux.waGroupId || '-',
          active: customerFromRedux.waNotifications ?? false,
        },
        {
          key: 'telegram',
          channel: 'Telegram',
          groupId: customerFromRedux.tgGroupId || '-',
          active: customerFromRedux.tgNotifications ?? false,
        },
      ]
    : [];

  const onCloseDrawer = () => {
    setVisible(false);
    setIsEditForm(false);
    setSelectedChannel(null);
  };

  const onShowDrawer = (action, record) => {
    if (action === 'notification_edit' && record) {
      setSelectedChannel(record.key);
      setIsEditForm(true);
    }
    setVisible(true);
  };

  const onSuccess = (updatedCustomer) => {
    if (updatedCustomer) {
      dispatch({
        type: 'customer.data',
        customer: { ...customerFromRedux, ...updatedCustomer },
      });
    } else {
      getCurrentMe().then(({ data }) => {
        if (data?.CurrentCustomer) {
          dispatch({ type: 'customer.data', customer: data.CurrentCustomer });
        }
      });
    }
  };

  if (!customerFromRedux?._id) {
    return (
      <PageContent
        title={I18n('list_notifications', true, true)}
        backIcon={false}
        onBack={() => {}}
        extra={[]}
      >
        <div style={{ padding: 24, textAlign: 'center' }}>{I18n('loading', true)}...</div>
      </PageContent>
    );
  }

  return (
    <>
      <PageContent
        title={I18n('list_notifications', true, true)}
        backIcon={false}
        onBack={() => {}}
        extra={[]}
      >
        <TableUI
          pagination={false}
          dataSource={dataChannels}
          loading={!customerFromRedux?._id}
          bordered
          rowKey={(record) => record.key}
          onRow={(record) => ({
            onClick: () => onShowDrawer('notification_edit', record),
          })}
        >
          <Column title={I18n('communication_channel', true)} dataIndex="channel" key="channel" />
          <Column title={I18n('group_id', true)} dataIndex="groupId" key="groupId" />
          <Column
            title={I18n('active', true)}
            dataIndex="active"
            key="active"
            render={(value) =>
              value ? (
                <span className="rk-tag-success">
                  <FontAwesomeIcon icon={faCheck} /> {I18n('active', true)}
                </span>
              ) : (
                <span className="rk-tag-error">
                  <FontAwesomeIcon icon={faTimes} /> {I18n('inactive', true)}
                </span>
              )
            }
          />
        </TableUI>
        <Drawer
          showTitle={true}
          title={`${I18n('update_notifications', true, true)} - ${
            selectedChannel === 'whatsapp' ? 'WhatsApp' : 'Telegram'
          }`}
          placement="right"
          onClose={onCloseDrawer}
          visible={visible}
          extra={[
            <div key="actions" className="rk-drawer-actions">
              <button
                onClick={onCloseDrawer}
                type="button"
                aria-label="Close"
                className="ant-drawer-close"
              >
                <FontAwesomeIcon icon={faTimesCircle} />
              </button>
            </div>,
          ]}
        >
          {customerFromRedux && isEditForm && selectedChannel && (
            <NotificationEdit
              customer={customerFromRedux}
              selectedChannel={selectedChannel}
              onCloseDrawer={onCloseDrawer}
              onSuccess={onSuccess}
            />
          )}
        </Drawer>
      </PageContent>
    </>
  );
}
